import apiService from './api';
import { showErrorToast } from '../utils';

class SuperAdminService {
  async getTenantKPIs() {
    try {
      const response = await apiService.get('/super-admin/dashboard/kpis');
      
      if (!response?.success) {
        throw new Error(response?.message || 'Failed to fetch tenant KPIs');
      }

      return response.data;
    } catch (error) {
      console.error('Error fetching tenant KPIs:', error);
      showErrorToast(error.message || 'Failed to load tenant KPIs');
      throw error;
    }
  }
}

const superAdminService = new SuperAdminService();

export default superAdminService;

